import { Component, Input, OnInit } from '@angular/core';
import { ICONS_PATH_PREFIX } from '../../../utils/constant';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-why-choose-positively-languages-reason',
  templateUrl: './why-choose-positively-languages-reason.component.html',
  styleUrls: ['./print-why-choose-positively-languages-reason.component.scss'],
})
export class WhyChoosePositivelyLanguagesReasonComponent implements OnInit {
  @Input() reasonImage: string | undefined;
  @Input() reasonTitle: string | undefined;
  @Input() reasonDescription: string | undefined;

  reasonImagePath!: string;

  ngOnInit(): void {
    this.reasonImagePath = `${ICONS_PATH_PREFIX}${this.reasonImage}`;
  }
}
